import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  className?: string;
}
export function CTAButton({
  text,
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full max-w-md mx-auto ${className}`} data-id="element-79">
      <motion.a href="https://pay.hotmart.com/M99112789Q?checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="w-full bg-brand-rose text-white font-bold py-4 px-6 rounded-full shadow-[0_8px_20px_rgba(201,123,99,0.3)] hover:shadow-[0_12px_25px_rgba(201,123,99,0.4)] transition-shadow duration-300 flex items-center justify-center gap-2 text-lg sm:text-xl" data-id="element-80">
        <Zap className="w-5 h-5 fill-current" data-id="element-81" />
        <span className="text-center leading-tight" data-id="element-82">{text}</span>
      </motion.a>

      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-4 text-xs sm:text-sm text-brand-textLight font-medium" data-id="element-83">
        <div className="flex items-center gap-1" data-id="element-84">
          <Lock className="w-4 h-4 text-brand-gold" data-id="element-85" />
          <span data-id="element-86">Pago 100% Seguro</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-87">
          <Zap className="w-4 h-4 text-brand-gold" data-id="element-88" />
          <span data-id="element-89">Acceso Inmediato</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-90">
          <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-91" />
          <span data-id="element-92">Garantía 7 Días</span>
        </div>
      </div>
    </div>;
}